import $ from 'jquery';

if ($('body').hasClass('page-aboutus')) {

  let scrollPos,
      section1 = $('.p-aboutus1'),
      section4 = $('.p-aboutus4 .c-imgtext07'),
      js_heightsc = $('.js-heightsc'),
      section1_offsetTop = section1.offset().top,
      section4_offsetTop,
      section4_height ,
      imgtext_sc1_offsetTop = section1.find('.c-imgtext07').offset().top,
      imgfixed = $('.js-imgfixed'),
      imgscale,
      body = $('body'),
      padding_top = 0,
      scroll_icon = $('.js-imgscrl'),
      scroll_percent,
      circle_percent


  $(window).on('scroll , load , resize', function (e) {
    scrollPos = $(window).scrollTop();

    if($(window).width() >= 768){
      if(scrollPos >= section1_offsetTop){
        imgfixed.addClass('is-active').css({ 'top' : imgtext_sc1_offsetTop - section1_offsetTop });
        scroll_percent = (scrollPos - section1_offsetTop) * 0.1;
        scroll_icon.attr('d' , 'M0 25L'+scroll_percent +' 25')

        section4_offsetTop = section4.offset().top;
        section4_height = $('.p-aboutus4').height();
        if($(window).width() <= 1024){
          padding_top = 104;
        }
        js_heightsc.each(function(){
       
          if(scrollPos >= $(this).offset().top - 145){
            let flag = 8 ;
            if($(this).index() >= 3){
              flag = 6
            }
            body.removeClass('is-bgsc1 is-bgsc2 is-bgsc3 is-bgsc4')
            body.addClass('is-bgsc'+$(this).index());
            imgscale = ((scrollPos - ($(this).offset().top - 145)) / flag) * 0.01
            circle_percent = (scrollPos - $(this).offset().top);
            if(circle_percent > 191){circle_percent = 191}
            if(imgscale > 1){imgscale = 1}
            imgfixed.find('.p-aboutus__image__img').removeClass('is-show');
            imgfixed.find('.js-imgfixed'+ $(this).index()).css({ 
              'opacity': 1,
            });
            $(this).find('.js-imgcircle').css({'stroke-dasharray' : circle_percent+', 266'});
            imgfixed.find('.js-imgfixed'+ $(this).index()).prev().css({ 'opacity' : 1 - imgscale })
          }else{
            imgfixed.find('.js-imgfixed'+ $(this).index()).css({ 
              'opacity' : 0,
            });
          }
        });
        
        if(scrollPos >= section4_offsetTop - 145){
          
          imgfixed.removeClass('is-active').css({
            'position' : 'absolute',
            'top' : section4_offsetTop - section4_height - padding_top
          });
        }else{
          imgfixed.removeClass('is-active').css({
            'position' : 'fixed',
            'top' : imgtext_sc1_offsetTop - section1_offsetTop
          });
        }
      }else{
        imgfixed.removeClass('is-active').css({
          'position' : 'absolute',
          'top' : 0
        });
        body.removeClass('is-bgsc1 is-bgsc2 is-bgsc3 is-bgsc4')
      }
    }

  });
}